import { render, staticRenderFns } from "./DwzcsqBrowse.vue?vue&type=template&id=5b735976"
import script from "./DwzcsqBrowse.vue?vue&type=script&lang=js"
export * from "./DwzcsqBrowse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports